import { simpleGet } from "../apiConfig"

export const getGuidelines = (ids, chemical_unit_ids) =>
  simpleGet(`/lab/guidelines`, { params: { ids, chemical_unit_ids } })
